import { render, staticRenderFns } from "./RankUpdown.vue?vue&type=template&id=1b8beb70&"
import script from "./RankUpdown.vue?vue&type=script&lang=js&"
export * from "./RankUpdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/hanmail/src/cafe-top/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('1b8beb70', component.options)
    } else {
      api.reload('1b8beb70', component.options)
    }
    module.hot.accept("./RankUpdown.vue?vue&type=template&id=1b8beb70&", function () {
      api.rerender('1b8beb70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/components/home/RankUpdown.vue"
export default component.exports